var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "GowerWebHeader" } },
    [
      _c(
        "b-navbar",
        {
          attrs: {
            toggleable: "md",
            type: _vm.navType,
            variant: _vm.navVariant,
          },
        },
        [
          _c("b-navbar-brand", [
            _vm._v("\n      " + _vm._s(_vm.state.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", {
            staticClass: "float-right",
            attrs: { target: "nav-collapse" },
          }),
          _vm._v(" "),
          _c("b-navbar-nav", { staticClass: "d-none d-md-flex" }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-none ml-md-auto d-block d-md-flex" },
                [
                  _vm.state.userId && _vm.state.helpEnable && !_vm.helpLocked
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "mr-0 mr-md-2",
                          on: { click: _vm.showHelp },
                        },
                        [_vm._v("\n          Help\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state.userId &&
                  _vm.state.feedbackEnable &&
                  !_vm.feedbackLocked
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "mr-0 mr-md-2",
                          on: { click: _vm.showFeedbackRequests },
                        },
                        [_vm._v("\n          Feedback\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state.notificationList &&
                  _vm.state.notificationList.length &&
                  !_vm.notificationLocked
                    ? _c(
                        "b-nav-item",
                        {
                          staticClass: "mr-0 mr-md-2",
                          on: { click: _vm.readNotifications },
                        },
                        [
                          _vm._v("\n          Updates\n          "),
                          _vm.state.notificationUnReadCount > 0
                            ? _c("b-badge", { attrs: { variant: "danger" } }, [
                                _vm._v(
                                  _vm._s(_vm.state.notificationUnReadCount)
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state.themeList.length && !_vm.themeLocked
                    ? _c(
                        "b-nav-item-dropdown",
                        { attrs: { text: _vm.theme || "No Theme", right: "" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeTheme($event, "")
                                },
                              },
                            },
                            [_vm._v("No Theme")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.state.themeList, function (theme) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: theme,
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeTheme($event, theme)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(theme))]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state.userId && _vm.state.tenants.length
                    ? _c(
                        "b-nav-item-dropdown",
                        { attrs: { text: _vm.tenantName, right: "" } },
                        _vm._l(_vm.state.tenants, function (tenant) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: tenant.id,
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeTenant($event, tenant.id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(tenant.name))]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "d-inline-block d-md-flex",
                      attrs: {
                        text: _vm.state.userFullName || _vm.state.userName,
                        right: "",
                      },
                    },
                    [
                      !_vm.state.userId
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.login()
                                },
                              },
                            },
                            [_vm._v("Login")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.state.userId
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.logout()
                                },
                              },
                            },
                            [_vm._v("Logout")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.changeRender()
                            },
                          },
                        },
                        [_vm._v(_vm._s(this.renderModeToggleDescription))]
                      ),
                      _vm._v(" "),
                      _vm.state.userId ? _c("b-dropdown-divider") : _vm._e(),
                      _vm._v(" "),
                      _vm.state.userId
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.editPreferences()
                                },
                              },
                            },
                            [_vm._v("Preferences")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.state.userId && _vm.state.canChangePassword
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.changePassword()
                                },
                              },
                            },
                            [_vm._v("Change Password")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.state.userId
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.shortenUrl()
                                },
                              },
                            },
                            [_vm._v("Shorten Url")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-breadcrumb", {
        staticClass: "d-print-none",
        attrs: { items: _vm.breadCrumbs },
        on: { click: _vm.breadCrumbClick },
      }),
      _vm._v(" "),
      _vm.breadCrumbs.length > 1
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-primary btn-sm float-right close-button d-print-none",
              on: { click: _vm.closeButtonClick },
            },
            [_vm._v("Close")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.headerMessages, function (message) {
        return _c(
          "b-alert",
          {
            key: message.text,
            attrs: {
              show: message.countdown || true,
              fade: "",
              variant: message.variant || "danger",
              dismissible: !!message.dismissable,
            },
          },
          [_vm._v(_vm._s(message.text))]
        )
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalNotifications",
          attrs: {
            id: "modalNotifications",
            title: "Notifications",
            size: "lg",
          },
          on: { ok: _vm.hideNotifications, hide: _vm.hideNotifications },
        },
        [
          _c(
            "div",
            { attrs: { role: "tablist" } },
            _vm._l(_vm.state.notificationList, function (notification) {
              return _c(
                "b-card",
                {
                  key: notification.id,
                  staticClass: "mb-1",
                  attrs: { "no-body": "" },
                },
                [
                  _c(
                    "b-card-header",
                    {
                      staticClass: "p-1",
                      attrs: { "header-tag": "header", role: "tab" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-left",
                          attrs: { block: "", variant: "info" },
                          on: {
                            click: function ($event) {
                              notification.isOpen = !notification.isOpen
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(notification.title) +
                              "\n            "
                          ),
                          !notification.isRead
                            ? _c(
                                "b-badge",
                                {
                                  staticClass: "float-right",
                                  attrs: { variant: "danger" },
                                },
                                [_vm._v("New!")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      attrs: {
                        id: "notification-" + notification.id.toString(),
                        role: "tabpanel",
                      },
                      model: {
                        value: notification.isOpen,
                        callback: function ($$v) {
                          _vm.$set(notification, "isOpen", $$v)
                        },
                        expression: "notification.isOpen",
                      },
                    },
                    [
                      _c(
                        "b-card-header",
                        [
                          _c(
                            "b-card-sub-title",
                            { staticClass: "font-italic" },
                            [
                              _vm._v(
                                " Sent by " +
                                  _vm._s(notification.createUserFullName) +
                                  " on " +
                                  _vm._s(
                                    _vm.formatDate(notification.createDate)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _c("b-card-text", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formatTextAsHtml(notification.text)
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalFeedbackRequests",
          attrs: {
            id: "modalFeedbackRequests",
            title: "My Feedback",
            size: "lg",
          },
          on: { ok: _vm.hideFeedbackRequests, hide: _vm.hideFeedbackRequests },
        },
        [
          _vm._l(_vm.modalMessages, function (message) {
            return _c(
              "b-alert",
              {
                key: message.text,
                attrs: {
                  show: message.countdown || true,
                  fade: "",
                  dismissible: "",
                  variant: message.variant || "danger",
                },
              },
              [_vm._v(_vm._s(message.text))]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { role: "tablist" } },
            [
              _c(
                "b-card",
                { staticClass: "mb-1", attrs: { "no-body": "" } },
                [
                  _c(
                    "b-card-header",
                    {
                      staticClass: "p-1",
                      attrs: { "header-tag": "header", role: "tab" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-left",
                          attrs: { block: "", variant: "info" },
                          on: {
                            click: function ($event) {
                              _vm.newFeedbackRequest.isOpen =
                                !_vm.newFeedbackRequest.isOpen
                            },
                          },
                        },
                        [_vm._v("\n            Make New Request\n          ")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      attrs: { id: "feedback-request-new", role: "tabpanel" },
                      model: {
                        value: _vm.newFeedbackRequest.isOpen,
                        callback: function ($$v) {
                          _vm.$set(_vm.newFeedbackRequest, "isOpen", $$v)
                        },
                        expression: "newFeedbackRequest.isOpen",
                      },
                    },
                    [
                      _c("b-card-body", [
                        _c("h5", [_vm._v("Title")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newFeedbackRequest.title,
                              expression: "newFeedbackRequest.title",
                            },
                          ],
                          staticClass: "form-control mt-1 mb-2",
                          attrs: { type: "text", maxlength: "512" },
                          domProps: { value: _vm.newFeedbackRequest.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.newFeedbackRequest,
                                "title",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("h5", [_vm._v("Request")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newFeedbackRequest.text,
                              expression: "newFeedbackRequest.text",
                            },
                          ],
                          staticClass: "form-control mt-1 mb-2",
                          attrs: { rows: "10" },
                          domProps: { value: _vm.newFeedbackRequest.text },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.newFeedbackRequest,
                                "text",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function ($event) {
                                return _vm.saveFeedbackRequest(
                                  _vm.newFeedbackRequest
                                )
                              },
                            },
                          },
                          [_vm._v("Create")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.feedbackRequests, function (feedbackRequest) {
                return _c(
                  "b-card",
                  {
                    key: feedbackRequest.id,
                    staticClass: "mb-1",
                    attrs: { "no-body": "" },
                  },
                  [
                    _c(
                      "b-card-header",
                      {
                        staticClass: "p-1",
                        attrs: { "header-tag": "header", role: "tab" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "text-left",
                            attrs: { block: "", variant: "info" },
                            on: {
                              click: function ($event) {
                                feedbackRequest.isOpen = !feedbackRequest.isOpen
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(feedbackRequest.title) +
                                "\n            "
                            ),
                            _c(
                              "b-badge",
                              {
                                staticClass: "float-right",
                                attrs: {
                                  variant:
                                    feedbackRequest.lookupStatusName === "New"
                                      ? "success"
                                      : "danger",
                                },
                              },
                              [_vm._v(_vm._s(feedbackRequest.lookupStatusName))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        attrs: {
                          id:
                            "feedback-request-" + feedbackRequest.id.toString(),
                          role: "tabpanel",
                        },
                        model: {
                          value: feedbackRequest.isOpen,
                          callback: function ($$v) {
                            _vm.$set(feedbackRequest, "isOpen", $$v)
                          },
                          expression: "feedbackRequest.isOpen",
                        },
                      },
                      [
                        _c(
                          "b-card-header",
                          [
                            _c(
                              "b-card-sub-title",
                              { staticClass: "font-italic" },
                              [
                                _vm._v(
                                  " Created by " +
                                    _vm._s(feedbackRequest.createUserFullName) +
                                    " on " +
                                    _vm._s(
                                      _vm.formatDate(feedbackRequest.createDate)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c("h5", [_vm._v("Request")]),
                            _vm._v(" "),
                            feedbackRequest.lookupStatusName === "New"
                              ? _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: feedbackRequest.text,
                                      expression: "feedbackRequest.text",
                                    },
                                  ],
                                  staticClass: "form-control mt-1 mb-2",
                                  attrs: { rows: "10" },
                                  domProps: { value: feedbackRequest.text },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        feedbackRequest,
                                        "text",
                                        $event.target.value
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            feedbackRequest.lookupStatusName !== "New"
                              ? _c("b-card-text", [
                                  _vm._v(_vm._s(feedbackRequest.text)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            feedbackRequest.devText
                              ? _c("h5", [_vm._v("Response")])
                              : _vm._e(),
                            _vm._v(" "),
                            feedbackRequest.devText
                              ? _c("b-card-text", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(feedbackRequest.devText) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            feedbackRequest.lookupStatusName === "New"
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveFeedbackRequest(
                                          feedbackRequest
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Update")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card-footer",
                          [
                            _c(
                              "b-card-sub-title",
                              { staticClass: "font-italic" },
                              [
                                _vm._v(
                                  " Updated by " +
                                    _vm._s(feedbackRequest.modifyUserFullName) +
                                    " on " +
                                    _vm._s(
                                      _vm.formatDate(feedbackRequest.modifyDate)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalUserPreferences",
          attrs: {
            id: "modalUserPreferences",
            title: "User Preferences",
            size: "lg",
          },
          on: { ok: _vm.updatePreferences, hide: _vm.hidePreferences },
        },
        [
          _vm._l(_vm.modalMessages, function (message) {
            return _c(
              "b-alert",
              {
                key: message.text,
                attrs: {
                  show: message.countdown || true,
                  fade: "",
                  dismissible: "",
                  variant: message.variant || "danger",
                },
              },
              [_vm._v(_vm._s(message.text))]
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Company")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.defaultCompanyId,
                        expression: "preferences.defaultCompanyId",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "defaultCompanyId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.state.tenants, function (tenant) {
                    return _c(
                      "option",
                      { key: tenant.id, domProps: { value: tenant.id } },
                      [_vm._v(_vm._s(tenant.name))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Email Address")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preferences.emailAddress,
                      expression: "preferences.emailAddress",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "100" },
                  domProps: { value: _vm.preferences.emailAddress },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.preferences,
                        "emailAddress",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12" }, [
              _c("label", { staticClass: "mb-0" }, [_vm._v("Options")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-control-plaintext border-0 pl-0" },
                [
                  _c("generic-toggle", {
                    attrs: { label: "Use Floating Table Headers" },
                    model: {
                      value: _vm.preferences.useFloatingTableHeaders,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.preferences,
                          "useFloatingTableHeaders",
                          $$v
                        )
                      },
                      expression: "preferences.useFloatingTableHeaders",
                    },
                  }),
                  _vm._v(" "),
                  _c("generic-toggle", {
                    attrs: { label: "Use Local Drawing Path" },
                    model: {
                      value: _vm.preferences.useLocalDrawingPathByDefault,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.preferences,
                          "useLocalDrawingPathByDefault",
                          $$v
                        )
                      },
                      expression: "preferences.useLocalDrawingPathByDefault",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Page Size")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.defaultPageSize,
                        expression: "preferences.defaultPageSize",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.preferences,
                            "defaultPageSize",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function ($event) {
                          return _vm.changePageSize()
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.lookups.pageSizes, function (pageSize) {
                    return _c(
                      "option",
                      { key: pageSize, domProps: { value: pageSize } },
                      [_vm._v(_vm._s(pageSize))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Floating Table Size")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.floatingTableHeightPixels,
                        expression: "preferences.floatingTableHeightPixels",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "floatingTableHeightPixels",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.lookups.floatingTableHeights, function (height) {
                    return _c(
                      "option",
                      { key: height, domProps: { value: height } },
                      [_vm._v(_vm._s(height) + " px")]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Phone Number")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preferences.phoneNumber,
                      expression: "preferences.phoneNumber",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "100" },
                  domProps: { value: _vm.preferences.phoneNumber },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.preferences,
                        "phoneNumber",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Find Quote Status")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.defaultStatus,
                        expression: "preferences.defaultStatus",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "defaultStatus",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option"),
                    _vm._v(" "),
                    _vm._l(_vm.lookups.statuses, function (status) {
                      return _c(
                        "option",
                        { key: status.name, domProps: { value: status.name } },
                        [_vm._v(_vm._s(status.description))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Find Quote Estimator")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.lookupDefaultEstimatorId,
                        expression: "preferences.lookupDefaultEstimatorId",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "lookupDefaultEstimatorId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.lookups.estimators, function (estimator) {
                    return _c(
                      "option",
                      { key: estimator.id, domProps: { value: estimator.id } },
                      [_vm._v(_vm._s(estimator.fullName))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Find Quote Salesperson")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.lookupDefaultSalesPersonId,
                        expression: "preferences.lookupDefaultSalesPersonId",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "lookupDefaultSalesPersonId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.lookups.salesPeople, function (salesPerson) {
                    return _c(
                      "option",
                      {
                        key: salesPerson.id,
                        domProps: { value: salesPerson.id },
                      },
                      [_vm._v(_vm._s(salesPerson.fullName))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Organization")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.defaultOrganizationId,
                        expression: "preferences.defaultOrganizationId",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "defaultOrganizationId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option"),
                    _vm._v(" "),
                    _vm._l(_vm.lookups.organizations, function (org) {
                      return _c(
                        "option",
                        { key: org.id, domProps: { value: org.id } },
                        [_vm._v(_vm._s(org.name))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Default Location")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferences.lookupDefaultLocationId,
                        expression: "preferences.lookupDefaultLocationId",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.preferences,
                          "lookupDefaultLocationId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.lookups.locations, function (location) {
                    return _c(
                      "option",
                      { key: location.id, domProps: { value: location.id } },
                      [_vm._v(_vm._s(location.name))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loaderVisible,
              expression: "loaderVisible",
            },
          ],
          staticClass: "loader-modal",
        },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("b-spinner", {
                staticClass: "ml-auto",
                staticStyle: { width: "10rem", height: "10rem" },
                attrs: { variant: "primary", label: "Spinning" },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("generic-eliza", { ref: "eliza" }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalUrl",
          attrs: { id: "modalUrl", title: "Your Shortened Url", size: "md" },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("p", [
              _vm._v(
                "Your shortened URL is below and has been automatically copied into the clipboard:"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "input-group mb-1" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shortenedUrl,
                      expression: "shortenedUrl",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.shortenedUrl },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.shortenedUrl = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group-append d-print-none" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          size: "md",
                          variant: "primary",
                          tag: "a",
                          href: _vm.shortenedUrl,
                          _target: "blank",
                        },
                      },
                      [_c("i", { staticClass: "fas fa-link" })]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("generic-confirm", { ref: "confirm" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }